import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../ResuableCompoment/Pagination";
import SearchBar from "../ResuableCompoment/SearchBar";
import useApi from "../CustomHooks/useApi";
import { useSelector } from 'react-redux';

const AddBankRequest = () => {
    const [loading, setLoading] = useState(true);
    const [formsData, setFormsData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rawResponse, setRawResponse] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState("");
    const [selectedAccountNumber, setSelectedAccountNumber] = useState("");
    const [actionLoading, setActionLoading] = useState(false);
    const [dropdownKey, setDropdownKey] = useState(0);
    
    // New states for reject reason
    const [rejectReason, setRejectReason] = useState("");
    const [reasonError, setReasonError] = useState("");
    
    // New states for document viewer
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [selectedDocumentUrl, setSelectedDocumentUrl] = useState("");
    const [documentLoading, setDocumentLoading] = useState(false);
    
    const itemsPerPage = 10;


    const { callApi: approvebankrequest } = useApi(
        `/itpay/aeps/backend/pending/account`,
        "GET"
    );

    const { callApi: updateaccount } = useApi(
        `/itpay/aeps/backend/approve/account`,
        "POST"
    );

    useEffect(() => {
        fetchFormsData();
    }, []);

    useEffect(() => {
        console.log("setrawdataa", rawResponse);
    }, [rawResponse]);

    const fetchFormsData = async () => {
        try {
            const response = await approvebankrequest();

            console.log("responceeeee", response);
            if (response?.length > 0) {
                setFormsData(response);
                setRawResponse(response);
            } else {
                setFormsData([]);
            }
            setLoading(false);
        } catch (err) {
            console.error("Error fetching data:", err);
            setLoading(false);
        }
    };

    const handleActionChange = (accountNumber, action) => {
        if (action) {
            setSelectedAccountNumber(accountNumber);
            setSelectedAction(action);
            setRejectReason("");
            setReasonError("");
            setShowConfirmModal(true);
        }
    };


    const handleConfirmAction = async () => {
    // Validate reason for reject action
    if (selectedAction === "REJECT" && !rejectReason.trim()) {
        setReasonError("Please provide a reason for rejection");
        return;
    }

    setActionLoading(true);
    setReasonError(""); // Clear any existing error
    
    try {
        // Find the selected form data to get the mid
        const selectedForm = formsData.find(form => form.beneficiaryAccountNumber === selectedAccountNumber);
        
        const bodyrequest = {
            accountNumber: selectedAccountNumber,
            action: selectedAction,
            mid: selectedForm?.mid
        };

        // Add reason to request if it's a reject action
        if (selectedAction === "REJECT" && rejectReason.trim()) {
            bodyrequest.reason = rejectReason.trim();
        }

        const response = await updateaccount(bodyrequest);
        console.log("Action response:", response);

        // Close modal and refresh data
        await fetchFormsData();

    } catch (error) {
        console.error("Error performing action:", error);
    } finally {
        // Always reset states after action completion (success or failure)
        setActionLoading(false);
        setShowConfirmModal(false);
        setSelectedAction("");
        setSelectedAccountNumber("");
        setRejectReason("");
        setReasonError("");
        setDropdownKey(prev => prev + 1); // Force dropdown reset
    }
};
    const handleCancelAction = () => {
        setShowConfirmModal(false);
        setSelectedAction("");
        setSelectedAccountNumber("");
        setRejectReason("");
        setReasonError("");
        setDropdownKey(prev => prev + 1); // Force dropdown reset
    };

    // New function to handle document viewing
    const handleViewDocument = (documentUrl) => {
        if (documentUrl) {
            setSelectedDocumentUrl(documentUrl);
            setShowDocumentModal(true);
            setDocumentLoading(true);
        }
    };

    // Function to close document modal
    const handleCloseDocumentModal = () => {
        setShowDocumentModal(false);
        setSelectedDocumentUrl("");
        setDocumentLoading(false);
    };

    // Function to handle iframe load
    const handleDocumentLoad = () => {
        setDocumentLoading(false);
    };

    const filteredForms = formsData.filter(
        (form) =>
            form?.beneMobileNumber?.includes(searchQuery) ||
            form?.beneficiaryAccountNumber?.includes(searchQuery)
    );

    return (
        <div className="min-h-screen p-6 bg-gray-100">
            <div className="flex items-center mb-6">
                <SearchBar
                    placeholder="Search by Name, Role, or Mobile"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="bg-white p-8 rounded-lg shadow-2xl"
            >
                <div className="w-full text-black p-4 rounded-lg shadow-2xl text-xl font-semibold text-center mb-4">
                    <strong>Approve Bank Request</strong>
                </div>

                {loading ? (
                    <div className="text-center text-gray-600 text-lg">Loading data...</div>
                ) : filteredForms.length === 0 ? (
                    <div className="text-center text-red-500 text-lg">No data found</div>
                ) : (
                    <Pagination
                        items={filteredForms}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        renderItems={(currentItems) => (
                            <div className="overflow-x-auto">
                                <table className="min-w-full bg-white border-collapse shadow-xl rounded-lg">
                                    <thead>
                                        <tr className="bg-teal-600 text-white text-left text-lg">
                                            <th className="px-6 py-3 border-b rounded-tl-lg">Name</th>
                                            <th className="px-6 py-3 border-b">Account Number</th>
                                            <th className="px-6 py-3 border-b">IFSC Code</th>
                                            <th className="px-6 py-3 border-b">Mobile Number</th>
                                            <th className="px-6 py-3 border-b">Merchant Mobile Number</th>
                                            <th className="px-6 py-3 border-b">Bank Name</th>
                                            <th className="px-6 py-3 border-b">Status</th>
                                            <th className="px-6 py-3 border-b">Document</th>
                                            <th className="px-6 py-3 border-b rounded-tr-lg">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((form, index) => (
                                            <tr
                                                key={index}
                                                className="text-gray-800 bg-gray-100 hover:bg-gray-200 transition duration-300"
                                            >
                                                <td className="px-6 py-3 border-b">{form?.beneficiaryAccountName}</td>
                                                <td className="px-6 py-3 border-b">{form?.beneficiaryAccountNumber}</td>
                                                <td className="px-6 py-3 border-b">{form?.beneficiaryIfscCode}</td>
                                                <td className="px-6 py-3 border-b">{form?.beneMobileNumber}</td>
                                                <td className="px-6 py-3 border-b">{form?.merchantMobileNumber}</td>
                                                <td className="px-6 py-3 border-b">{form?.bankName}</td>
                                                <td className="px-6 py-3 border-b">
                                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                        form?.status === 'APPROVED' ? 'bg-green-100 text-green-800' :
                                                        form?.status === 'REJECTED' ? 'bg-red-100 text-red-800' :
                                                        form?.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                                                        'bg-gray-100 text-gray-800'
                                                    }`}>
                                                        {form?.status}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-3 border-b">
                                                    {form?.bankDocumentUrl ? (
                                                        <button
                                                            onClick={() => handleViewDocument(form?.bankDocumentUrl)}
                                                            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm transition duration-200"
                                                        >
                                                            View Document
                                                        </button>
                                                    ) : (
                                                        <span className="text-gray-400 text-sm">No Document</span>
                                                    )}
                                                </td>
                                                <td className="px-6 py-3 border-b">
                                                    <select
                                                        key={`${form?.beneficiaryAccountNumber}-${dropdownKey}`}
                                                        className="bg-white border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                                                        onChange={(e) => handleActionChange(form?.beneficiaryAccountNumber, e.target.value)}
                                                        value=""
                                                    >
                                                        <option value="" disabled>Select Action</option>
                                                        <option value="ACCEPT">Approve</option>
                                                        <option value="REJECT">Reject</option>
                                                        <option value="DELETE">Delete</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    />
                )}
            </motion.div>

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">
                            Confirm Action
                        </h3>
                        <p className="text-gray-600 mb-4">
                            Are you sure you want to <strong>{selectedAction}</strong> the account number <strong>{selectedAccountNumber}</strong>?
                        </p>
                        
                        {/* Reason input for REJECT action */}
                        {selectedAction === "REJECT" && (
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Reason for Rejection <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    value={rejectReason}
                                    onChange={(e) => {
                                        setRejectReason(e.target.value);
                                        if (reasonError) setReasonError("");
                                    }}
                                    placeholder="Please provide a reason for rejection..."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent resize-none"
                                    rows="3"
                                    disabled={actionLoading}
                                />
                                {reasonError && (
                                    <p className="text-red-500 text-sm mt-1">{reasonError}</p>
                                )}
                            </div>
                        )}
                        
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={handleCancelAction}
                                className="px-4 py-2 text-gray-600 bg-gray-200 rounded hover:bg-gray-300 transition duration-200"
                                disabled={actionLoading}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmAction}
                                className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 transition duration-200 disabled:opacity-50"
                                disabled={actionLoading}
                            >
                                {actionLoading ? "Processing..." : "OK"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Document Viewer Modal */}
            {showDocumentModal && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] flex flex-col">
                        {/* Modal Header */}
                        <div className="flex justify-between items-center p-4 border-b">
                            <h3 className="text-lg font-semibold text-gray-900">
                                Bank Document
                            </h3>
                            <button
                                onClick={handleCloseDocumentModal}
                                className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition duration-200"
                            >
                                ×
                            </button>
                        </div>
                        
                        {/* Modal Body */}
                        <div className="flex-1 p-4 relative">
                            {documentLoading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
                                    <div className="text-center">
                                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-2"></div>
                                        <p className="text-gray-600">Loading document...</p>
                                    </div>
                                </div>
                            )}
                            
                            {selectedDocumentUrl && (
                                <iframe
                                    src={selectedDocumentUrl}
                                    className="w-full h-96 border rounded"
                                    onLoad={handleDocumentLoad}
                                    title="Bank Document"
                                />
                            )}
                            
                            {/* Alternative: Open in new tab button */}
                            <div className="mt-4 text-center">
                                <a
                                    href={selectedDocumentUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 transition duration-200"
                                >
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                    Open in New Tab
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddBankRequest;